import { SectionsAnalyticsPage } from "../SectionsAnalyticsPage/index";

const SectionsAnalyticsTimePage = () => (
  <SectionsAnalyticsPage analyticsType="announceMessage" />
);

export default SectionsAnalyticsTimePage;
